namespace $ {
	export class $mol_stack extends $mol_view {
	}
	
}

